import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';

import { LoguinGuard } from './guard/loguin.guard';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutsComponent } from './component/layouts/layouts.component';
import { AsideComponent } from './component/layouts/aside/aside.component';
import { MainComponent } from './component/layouts/main/main.component';
import { FooterComponent } from './component/layouts/footer/footer.component';
import { NavbarComponent } from './component/layouts/navbar/navbar.component';
import { BrandComponent } from './component/product/brand/brand.component';
import { CategoryComponent } from './component/product/category/category.component';
import { LoginComponent } from './pages/login/login.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { authInterceptorProviders } from './services/interceptor/auth.interceptor';
import { UTFInterceptorProviders } from './services/interceptor/utf8.interceptor.ts.interceptor';
import { SharedModule } from './shared/shared-module';

@NgModule({
  declarations: [
    AppComponent,
    LayoutsComponent,
    AsideComponent,
    MainComponent,
    FooterComponent,
    NavbarComponent,
    BrandComponent,
    CategoryComponent,
    LoginComponent,
    SignUpComponent,
  ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-bottom-right',
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBackgroundColour: 'rgba(222,221,221,0.5)',
      primaryColour: '#ff9a23',
      secondaryColour: '#ff9a23',
      tertiaryColour: '#ff9a23',
      fullScreenBackdrop: true,
    }),

  ],
  providers: [authInterceptorProviders, UTFInterceptorProviders, LoguinGuard],
  bootstrap: [AppComponent],
})
export class AppModule {}
